import React from 'react'
import SkillsItem from './SkillsItem'
import HealthBar from "./HealthBar"
import "./aside.css";

export default function SkillsAside({localData, apiData}) {

    const objToPrint = {
        "HP": [localData.currentStats.HP, localData.currentStats.MaxHP],
        "ATTACK": localData.currentStats.ATTACK,
        "DEFENSE": localData.currentStats.DEFENSE,
        "SP.ATK": localData.currentStats.SPATTACK,
        "SP.DEF": localData.currentStats.SPDEFENSE,
        "SPEED": localData.currentStats.SPEED
    }
    const claves = Object.keys(objToPrint)
    const valores = Object.values(objToPrint)


  return (
      <aside className="data yellow-border-top">
          {
              claves.map((clave, indice) => {
                  if(clave === "HP"){
                      let porcentaje = (valores[indice][0] * 100 ) / valores[indice][1]
                        return(
                            <>
                                <SkillsItem clave={clave} valor={`${valores[indice][0]}/${valores[indice][1]}`} key={"skill-item" + indice} />
                                <HealthBar hp={porcentaje} key={"hp" + indice}></HealthBar>
                            </>
                        )
                  }
                  else return <SkillsItem clave={clave} valor={valores[indice]} key={"skill-items" + clave} />
              })
          }
      </aside>
  )
}
